import React, { useEffect,useState } from 'react'
import { useWallet } from '@binance-chain/bsc-use-wallet'
  
function ConnectModal() {

  const {account,connect} = useWallet();
  return (
    <>
      <div className="modal fade popup" id="popup_bid" tabIndex={-1} role="dialog" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="close icon" data-dismiss="modal" aria-label="Close">
              <img src="assets/images/backgroup/bg_close.png" alt="" />
            </div>
            <div className="header-popup">
              <h5>Select a Wallet</h5>
              <div className="desc">
                By connecting your wallet, you agree to our <a href="#">Terms of Service</a> and our <a href="#">Privacy Policy</a>.
              </div>
              <div className="spacing" /> 
            </div>
            <div className="modal-body center">
              <div className="connect-wallet"> 
                <ul>
                  <li onClick={()=>{connect("injected")}}>
                    <a href="#"><img src="assets/images/common/wallet_5.png" alt="" />
                      <span>MetaMask</span>
                      <span className="icon">
                        <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.1875 1.375L6.8125 7L1.1875 12.625" stroke="#798DA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg> 
                      </span>
                    </a>
                  </li>
                  <li onClick={()=>{connect("injected")}}>
                    <a href="#">
                      <img src="https://trustwallet.com/assets/images/media/assets/TWT.png" alt="" />
                      <span>Trust Walet</span>
                      <span className="icon">
                        <svg width={8} height={14} viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1.1875 1.375L6.8125 7L1.1875 12.625" stroke="#798DA3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg> 
                      </span>
                    </a>
                  </li>
                  
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ConnectModal;





